import React from "react";
import { Loader, DepositForm, PageLayout } from "src/components";
import { TrustPaymentsDepositForm } from "src/components/depositForm";
import { useDepositWithdrawContext } from "src/contexts";
import { usePaymentsRoutes } from "src/hooks";

const TRUSTPAYMENTS = "TRUSTPAYMENTS";

const DepositPage: React.FC = (): JSX.Element => {
  const { widgetDataLoading, widgetDataError } = useDepositWithdrawContext();
  const { paymentsRoutes, paymentsRoutesLoading, paymentsRoutesError } = usePaymentsRoutes();

  if (widgetDataLoading || widgetDataError || paymentsRoutesLoading || paymentsRoutesError) {
    return <Loader />;
  }

  const isTrust = paymentsRoutes.psp_service_id === TRUSTPAYMENTS;

  return (
    <PageLayout borderless={isTrust}>
      {isTrust ? <TrustPaymentsDepositForm route={paymentsRoutes} /> : <DepositForm />}
    </PageLayout>
  );
};

export default DepositPage;
